import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/system';
import { t } from 'i18next';

interface Props {
  title?: string;
  sx?: SxProps<Theme>;
}

const NotSpecified = ({ title, sx }: Props) => {
  return (
    <Typography
      variant={'body2'}
      sx={{ fontWeight: 'medium', fontStyle: 'italic', ...sx }}
    >
      {title || t('common.not_specified')}
    </Typography>
  );
};

export { NotSpecified };
